// extracted by mini-css-extract-plugin
export default {"container":"ComponentLoader_container__6rTM5","loader":"ComponentLoader_loader__ji+PD"};